module.exports = __webpack_public_path__ + "static/media/forsta.3f36fb19.m4a";